import { useEffect, type ReactNode } from 'react'

import { useAuthToken } from '@/hooks/useAuthToken'

import { useHeartbeatTimer } from '../hooks/useHeartbeatTimer'
import { ActivityRegistry } from '../registry/activity-registry'
import { DomEventsActivitySource } from '../sources/dom-events-source'
import { LiveSessionPresenceSource } from '../sources/live-session-presence-source'
import { RouteChangeSource } from '../sources/route-change-source'
import type { RouterSubscribe } from '../types/activity-source'

type Props = {
  readonly routerSubscribe: RouterSubscribe
  readonly children: ReactNode
}

export function SessionHeartbeatProvider({ routerSubscribe, children }: Props) {
  const { isSignedIn } = useAuthToken()

  useEffect(() => {
    if (!isSignedIn) return

    const domSource = new DomEventsActivitySource()
    const routeSource = new RouteChangeSource(routerSubscribe)
    const liveSessionSource = new LiveSessionPresenceSource(routerSubscribe)

    ActivityRegistry.register(domSource)
    ActivityRegistry.register(routeSource)
    ActivityRegistry.register(liveSessionSource)

    return () => {
      ActivityRegistry.clear()
    }
  }, [isSignedIn, routerSubscribe])

  useHeartbeatTimer()

  return <>{children}</>
}
